<div class='detailcontainer'>
  <mat-toolbar color='accent'>
    <ldw-document-title [document]='document'></ldw-document-title>
    <span class='spacer'></span>
    <div class='buttons'>
      <button mat-icon-button (click)='close()' matTooltip="{{ showToolTip()? ('DIALOGS.CLOSE' | translate):'' }}">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <div class='detailcontent'>
    <form [formGroup]='form' (submit)='startCopy()'>
      <mat-list>
        @for (group of visibleGroups; track group) {
          <div [formGroup]='form' class='form-row'>
            <ldw-vmp-form-group
              [groupCaptionText]='group.groupName'
              [expanded]="group.groupName === 'Navigation'"
              [captionWidth]='captionWidth'
              [form]='form'
              [vmpList]='group.fields'
              (actionClicked)=openFormControlDialog($event)
            ></ldw-vmp-form-group>
          </div>
        }
      </mat-list>
      <!-- hidden input required for submit with enter -->
      <button class='hiddenbutton' submit></button>
    </form>
  </div>
</div>
<div>
  <button   mat-stroked-button   class="change-pwd-btn mat-stroked-button default-background-stroked-button"
    (click)="startCopy()"
    [disabled]='form.disabled'
    >
    {{ 'DIALOGS.COPY' | translate }}
  </button>
  <button  mat-stroked-button   class="change-pwd-btn mat-stroked-button default-background-stroked-button"
    (click)="close()"
    >
    {{ 'DIALOGS.CANCEL' | translate }}
  </button>


</div>
